// extracted by mini-css-extract-plugin
module.exports =  {"root":"FyXwv4dXtxJ6B1xegRwB","instagramIndicator":"NGVbMzbWqmKQlThIfoX8"};